const AJUSTE_INVENTARIO = (state, ajuste_inventario) => {
    state.ajuste_inventario = ajuste_inventario;
};

export default {
    AJUSTE_INVENTARIO,
};